import React, { createContext, useState, useContext } from "react";


const CurrencyContext = createContext();


export const CurrencyProvider = ({ children }) => {
  const [rate, setRate] = useState({"$":1}); 

  
  const updateRate = (newRate) => {
    setRate(newRate);
  };

  return (
    <CurrencyContext.Provider value={{ rate, updateRate }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  return useContext(CurrencyContext);
};